
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import PcSideChatPanel from '@/components/chat/PcSideChatPanel.vue';
import { Tr } from '@/i18n/i18n';

@Component({
  components: { PcSideChatPanel },
})
export default class PcSideChatsBanner extends Vue {
  @Prop({ default: false }) private open!: boolean;

  get trClanChat() { return Tr('chat.clana').toUpperCase(); }
  get trChat() { return Tr('chat'); }
  get trWriteClan() { return Tr('napisat.klanu'); }
  get trWrite() { return Tr('write.message'); }
}
